module.exports = __webpack_public_path__ + "trustpilot-logo-11de56e1.svg";